var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIosCircle = function SvgIosCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.207,
    cy: 12.1797,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M14.5973 5.80469C13.9176 5.8517 13.1231 6.28679 12.6601 6.85337C12.2378 7.36735 11.8904 8.13075 12.0258 8.87263C12.7685 8.89574 13.5359 8.45029 13.9806 7.87416C14.3965 7.33786 14.7113 6.57924 14.5973 5.80469Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M17.2833 10.0824C16.6306 9.264 15.7134 8.78906 14.8472 8.78906C13.7037 8.78906 13.22 9.33651 12.4256 9.33651C11.6064 9.33651 10.984 8.79066 9.99511 8.79066C9.02373 8.79066 7.9894 9.38432 7.33357 10.3995C6.41159 11.8291 6.56937 14.517 8.0635 16.8064C8.5982 17.6255 9.3122 18.5467 10.2461 18.5547C11.0773 18.5627 11.3115 18.0216 12.4375 18.016C13.5635 18.0096 13.7771 18.5619 14.6066 18.5531C15.5413 18.5459 16.2944 17.5251 16.8291 16.706C17.2124 16.1187 17.355 15.823 17.6522 15.16C15.4903 14.3369 15.1437 11.2625 17.2833 10.0824Z"
  })));
};
export default SvgIosCircle;